import { render, staticRenderFns } from "./PageDetailTable.vue?vue&type=template&id=0b440bb3&scoped=true&"
import script from "./PageDetailTable.vue?vue&type=script&lang=ts&"
export * from "./PageDetailTable.vue?vue&type=script&lang=ts&"
import style0 from "./PageDetailTable.vue?vue&type=style&index=0&id=0b440bb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b440bb3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VFileInput,VSimpleTable,VTextField,VTextarea})
